// Constants for the Table Design Tab
export var BORDERS_SHADING_GROUP_ID = '_borders_shading_group';
export var SHADING_GROUP_ID = '_shading_group';
// Constants for Borders & Shading items
export var BORDERS_DROPDOWN_ID = '_borders_dropdown';
export var BORDER_COLOR_PICKER_ID = '_border_color_picker';
export var BORDER_WIDTH_DROPDOWN_ID = '_border_width_dropdown';
export var SHADING_COLOR_PICKER_ID = '_shading_color_picker';
